import * as React from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { FormControl, InputLabel, MenuItem, Select, TextField, FormHelperText } from '@mui/material';
import getJournalService from '../../../../services/getJournalService';
import getCategoryService from '../../../../services/getCategoryService';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const AddEdit = ({ dialogType, fetchData, editValue, isOpen, setIsOpen, setEditValue }) => {
    const [loading, setLoading] = React.useState(false);
    // Define Yup validation schema
    const validationSchema = Yup.object({
        name: Yup.string().required(' Name is required'),
        // link: Yup.string().url('Invalid URL').required('Journal Link is required'),
        // issnNumber: Yup.string().required('ISSN Number is required'),
    });

    // Set up Formik
    const formik = useFormik({
        initialValues: {
            name: editValue?.name || '',
            // link: editValue?.link || '',
            // issnNumber: editValue?.issnNumber || '',
        },
        validationSchema: validationSchema,
        enableReinitialize: true,
        onSubmit: async (values) => {
            setLoading(true);
            if (dialogType === 'edit') {
                // Update existing journal
                try {
                    let respons = await getJournalService.UpdateJournalList(values, editValue.id);
                    fetchData()
                } catch (error) {
                    console.error('Error editing category:', error);
                }
            } else {
                // Add new journal
                try {
                    let respons = await getJournalService.CreateJournal(values);
                    fetchData()
                } catch (error) {
                    console.error('Error editing category:', error);
                }
            }
            handleClose();
            setLoading(false);
        },
    });
    const handleClose = () => {
        setIsOpen(false);
        formik.resetForm();
        setEditValue({})
    };
    return (
        <React.Fragment>
            <Dialog
                open={isOpen}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                fullWidth={true}
                maxWidth={'sm'}
            >
                <DialogTitle className='pt-3 modal_header_dealog'>{dialogType === 'edit' ? 'Edit Publication' : 'Add Publication'}</DialogTitle>
                <form onSubmit={formik.handleSubmit}>
                    <DialogContent>
                        <FormControl className='mt-3' fullWidth>
                            <TextField
                                size="small"
                                label="Publication Name"
                                name="name"
                                variant="outlined"
                                value={formik.values.name}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.name && Boolean(formik.errors.name)}
                                helperText={formik.touched.name && formik.errors.name}
                            />
                            {/* <TextField
                                className='mt-3'
                                size="small"
                                label="Journal Link"
                                name="link"
                                variant="outlined"
                                value={formik.values.link}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.link && Boolean(formik.errors.link)}
                                helperText={formik.touched.link && formik.errors.link}
                            />
                            <TextField
                                className='mt-3'
                                size="small"
                                label="ISSN Number"
                                name="issnNumber"
                                variant="outlined"
                                value={formik.values.issnNumber}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.issnNumber && Boolean(formik.errors.issnNumber)}
                                helperText={formik.touched.issnNumber && formik.errors.issnNumber}
                            /> */}
                        </FormControl>
                    </DialogContent>
                    <DialogActions className='pb-3'>
                        <Button variant="contained" color='error' onClick={handleClose} disabled={loading}>Cancel</Button>
                        <Button variant="contained" color='success' type="submit" disabled={loading}>
                            {loading
                                ? (dialogType === 'edit' ? 'Updating...' : 'Adding...')
                                : (dialogType === 'edit' ? 'Update Publication' : 'Add Publication')}
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
        </React.Fragment>
    );
};

export default AddEdit;
